const performance: Performance = window.performance

function startString (name: string): string {
  return `${ name } start`
}

function endString (name: string): string {
  return `${ name } end`
}

export namespace Performance {
  export function start(name: string): void {
    if (performance && performance.mark) {
      performance.mark(startString(name))
    }
  }

  export function end(name: string): void {
    if (performance && performance.mark) {
      performance.mark(endString(name))
    }
  }

  export function endAndMeasure(name: string, startEvent: string): void {
    end(name)
    measure(name, startEvent, name)
  }

  export function measure(name: string, startName: string, endName: string): void {
    if (performance && performance.measure) {
      performance.measure(name, startString(startName), endString(endName))
    }
  }
}
